import './LoginPage.css';
import BackImg from './assets/back.png'
import LogoImg from './assets/logo.png'
import { loginapi } from "../../network/api/user";
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate()

  const handellogin = (e) => {
    e.preventDefault();
    loginapi({ email, password })
      .then((result) => {
        if (result === true) {
          window.location.reload();
          navigate('/')
        } else {
          setError("invalid Email OR Password");
          setTimeout(() => {
            setError("");
          }, 2000);
        }
      })
      .catch((err) => { });
  };

  return (
    <div className='d-flex login-page' style={{ direction: 'rtl' }}>
      <div className="contain">
        <div className="">
          <h2>{t("login")}</h2>
          <p>{t("pleaseLoginToContinue")}</p>
          <form action="" onSubmit={handellogin}>
            <div className="inp">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
                placeholder={t("email")}
              />
            </div>
            <div className="inp my-2 d-flex flex-row-reverse gap-2">
              <input
                type="password"
                placeholder={t("password")}
                id="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </div>
            {error && (
              <div className="alert alert-danger text-center h-25" role="alert"
              >{error}
              </div>
            )}
            <div className="d-flex justify-content-end">
              <button className='forget'>{t("forgetpassword")}</button>
            </div>
            <input type="submit" value="Login" className='submit' />
            <div className="media mt-4 ">
              <span>{t("loginWithGoogle")}</span>
              {GoogleIcon}
            </div>
            <div className="media">
              <span>{t("loginWithFacebook")}</span>
              {FacebookIcon}
            </div>
            <div className="media">
              <span>{t("loginWithTwitter")}</span>
              {TwitterIcon}
            </div>
            <div className="go-to-page d-flex justify-content-center mt-4 gap-1">
              <Link to={'/signup'}> {t("createOne")} </Link>
              <span> {t("needAnAccount")} </span>
            </div>
          </form>
        </div>
      </div>
      <div className="logo-container d-none d-lg-block">
        <img src={BackImg} alt='back' className='back' />
        <img src={LogoImg} alt='loggo' className='logoo' />
      </div>
    </div>
  )
}
export default LoginPage;

const GoogleIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1606_5814" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path d="M23.7209 9.81818H12.2791V14.4545H18.8651C18.2512 17.4 15.6837 19.0909 12.2791 19.0909C8.26047 19.0909 5.02326 15.9273 5.02326 12C5.02326 8.07273 8.26047 4.90909 12.2791 4.90909C14.0093 4.90909 15.5721 5.5091 16.8 6.49092L20.3721 3C18.1953 1.14545 15.4047 0 12.2791 0C5.46977 0 0 5.34545 0 12C0 18.6545 5.46977 24 12.2791 24C18.4186 24 24 19.6364 24 12C24 11.2909 23.8884 10.5273 23.7209 9.81818Z" fill="white" />
  </mask>
  <g mask="url(#mask0_1606_5814)">
    <path d="M-1.11719 19.0886V4.90674L8.37119 11.9976L-1.11719 19.0886Z" fill="#FBBC05" />
  </g>
  <mask id="mask1_1606_5814" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path d="M23.7209 9.81818H12.2791V14.4545H18.8651C18.2512 17.4 15.6837 19.0909 12.2791 19.0909C8.26047 19.0909 5.02326 15.9273 5.02326 12C5.02326 8.07273 8.26047 4.90909 12.2791 4.90909C14.0093 4.90909 15.5721 5.5091 16.8 6.49092L20.3721 3C18.1953 1.14545 15.4047 0 12.2791 0C5.46977 0 0 5.34545 0 12C0 18.6545 5.46977 24 12.2791 24C18.4186 24 24 19.6364 24 12C24 11.2909 23.8884 10.5273 23.7209 9.81818Z" fill="white" />
  </mask>
  <g mask="url(#mask1_1606_5814)">
    <path d="M-1.11719 4.90967L8.37118 12.0006L12.2782 8.67332L25.6735 6.54603V-1.09033H-1.11719V4.90967Z" fill="#EA4335" />
  </g>
  <mask id="mask2_1606_5814" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path d="M23.7209 9.81818H12.2791V14.4545H18.8651C18.2512 17.4 15.6837 19.0909 12.2791 19.0909C8.26047 19.0909 5.02326 15.9273 5.02326 12C5.02326 8.07273 8.26047 4.90909 12.2791 4.90909C14.0093 4.90909 15.5721 5.5091 16.8 6.49092L20.3721 3C18.1953 1.14545 15.4047 0 12.2791 0C5.46977 0 0 5.34545 0 12C0 18.6545 5.46977 24 12.2791 24C18.4186 24 24 19.6364 24 12C24 11.2909 23.8884 10.5273 23.7209 9.81818Z" fill="white" />
  </mask>
  <g mask="url(#mask2_1606_5814)">
    <path d="M-1.11719 19.0915L15.627 6.54603L20.0363 7.09149L25.6735 -1.09033V25.0915H-1.11719V19.0915Z" fill="#34A853" />
  </g>
  <mask id="mask3_1606_5814" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path d="M23.7209 9.81818H12.2791V14.4545H18.8651C18.2512 17.4 15.6837 19.0909 12.2791 19.0909C8.26047 19.0909 5.02326 15.9273 5.02326 12C5.02326 8.07273 8.26047 4.90909 12.2791 4.90909C14.0093 4.90909 15.5721 5.5091 16.8 6.49092L20.3721 3C18.1953 1.14545 15.4047 0 12.2791 0C5.46977 0 0 5.34545 0 12C0 18.6545 5.46977 24 12.2791 24C18.4186 24 24 19.6364 24 12C24 11.2909 23.8884 10.5273 23.7209 9.81818Z" fill="white" />
  </mask>
  <g mask="url(#mask3_1606_5814)">
    <path d="M25.6755 25.0886L8.37318 11.9976L6.14062 10.3613L25.6755 4.90674V25.0886Z" fill="#4285F4" />
  </g>
</svg>
);

const FacebookIcon = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" rx="12" fill="#0B84EE" />
  <path d="M12.9927 12.2187H15.226L15.5766 9.93613H12.9922V8.68861C12.9922 7.7404 13.3002 6.89958 14.1818 6.89958H15.5984V4.90765C15.3495 4.87383 14.8231 4.7998 13.8284 4.7998C11.7514 4.7998 10.5336 5.90338 10.5336 8.41763V9.93613H8.39844V12.2187H10.5336V18.4924C10.9565 18.5564 11.3848 18.5998 11.8245 18.5998C12.2219 18.5998 12.6098 18.5632 12.9927 18.5112V12.2187Z" fill="white" />
</svg>
);

const TwitterIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#55ACE3" />
    <path d="M18.3616 8.9398C17.9416 9.1198 17.4616 9.2398 16.9816 9.2998C17.4616 8.9998 17.8816 8.51981 18.0616 7.97981C17.5816 8.27981 17.1016 8.45981 16.5016 8.57981C16.0816 8.09981 15.4216 7.7998 14.7616 7.7998C13.4416 7.7998 12.3616 8.8798 12.3616 10.1998C12.3616 10.3798 12.3616 10.5598 12.4216 10.7398C10.4416 10.6198 8.64156 9.6598 7.44156 8.2198C7.26156 8.5798 7.14156 8.9998 7.14156 9.4198C7.14156 10.2598 7.56156 10.9798 8.22156 11.3998C7.80156 11.3998 7.44156 11.2798 7.14156 11.0998C7.14156 12.2398 7.98156 13.2598 9.06156 13.4398C8.88156 13.4998 8.64156 13.4998 8.40156 13.4998C8.22156 13.4998 8.10156 13.4998 7.92156 13.4398C8.22156 14.3998 9.12156 15.1198 10.2016 15.1198C9.36156 15.7798 8.34156 16.1398 7.20156 16.1398C7.02156 16.1398 6.84156 16.1398 6.60156 16.0798C7.68156 16.7398 8.94156 17.1598 10.3216 17.1598C14.7616 17.1598 17.1616 13.4998 17.1616 10.3198V10.0198C17.6416 9.8398 18.0616 9.4198 18.3616 8.9398Z" fill="white" />
  </svg>
);